import _ from 'lodash';
export var getClassNames = function getClassNames(classNames) {
  return _.filter(classNames, function (c) {
    return _.isString(c);
  }).join(' ');
};